import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

const rubyType = 'declaration'
const storeType = 'declarations'

export const PEDeclarationCardActions = {
  initPeDeclarationCard: ({ commit }, index) => {
    commit('setPeDeclarationCardLock', { index, lock: true })
  },
  peFetchDeclarationCards: async ({ commit, getters }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/asylum_assistants`, { params: { type: rubyType } }).
      then(({ data }) => {
        const assistantCards = data?.asylum_assistant
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: assistantCards || [],
        })
      })
  },
  peDeclarationCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post(`/parties/${party.id}/asylum_assistants`, {
        asylum_assistant: {
          type: rubyType,
          value: {
            kind: section.kind,
            interpreter_full_name: section.interpreter_full_name,
            source_language: section.source_language,
            narrative: section.narrative,
          },
        },
      }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeDeclarationCardLock', { index: 'new', lock: true })
        commit('setPeDeclarationCardLock', { index: data.id, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peDeclarationCardDownloadPDF: async ({ getters }) => {
    const party = getters.peParty

    return await axiosRequest.
      post(`/parties/${party.id}/asylum_assistant_download`).
      then(({ data }) => data).
      catch(handleError)
  },
  peDeclarationCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/asylum_assistants/${section.id}`, { params: { type: rubyType } }).
      then(({ data }) => {
        commit('setPeDeclarationCardLock', { index, lock: true })
        commit('pePatchAsylumAssistant', {
          assistant: storeType,
          value: data,
        })
      }).
      catch(handleError)
  },
  peDeclarationCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/parties/${party.id}/asylum_assistants/${id}`, {
        asylum_assistant: {
          type: rubyType,
          value: {
            kind: section.kind,
            interpreter_full_name: section.interpreter_full_name,
            source_language: section.source_language,
            narrative: section.narrative,
          },
        },
      }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeDeclarationCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peDeclarationCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/parties/${party.id}/asylum_assistants/${id}`, { params: { type: rubyType } }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeDeclarationCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peDeclarationCardAddSection: ({ commit }) => {
    commit('setPeDeclarationCardLock', { index: 'new', lock: false })
    commit('addPeDeclarationCardSection', {
      id: null,
      kind: '',
      interpreter_full_name: '',
      source_language: '',
      narrative: '',
    })
  },
}

export const PEDeclarationCardMutations = {
  setPeDeclarationCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.DeclarationCard) Vue.set(state.partyEdit.partySections, 'DeclarationCard', {})
    Vue.set(state.partyEdit.partySections.DeclarationCard, index, lock)
  },
  addPeDeclarationCardSection: (state, section) => state.partyEdit.asylumAssystant[storeType].push(section),
  peDeclarationCardCreateUndo: state => {
    state.partyEdit.asylumAssystant[storeType].pop()
    Vue.set(state.partyEdit.partySections.DeclarationCard, 'new', true)
  },
}

export const PEDeclarationCardGetters = {
  peDeclarationCardLock: state => index => state.partyEdit.partySections.DeclarationCard[index],
  peDeclarationCardHasNewSection: state => !!state.partyEdit.asylumAssystant[storeType]?.find(declaration => declaration.id === null),
}
